<template>
  <div id="app">
    <Nav></Nav>
    <div class="toptit"></div>
    <div class="block">
      <h1><span>卡恩</span>拥有逾20年整合营销市场经验</h1>
    </div>
    <div class="course">
      <img src="../assets/course-shu.png" alt="">

    </div>
    <BottomNav style="margin-top:-10px"></BottomNav>

  </div>
</template>

<script>
import Nav from '../components/Nav'
import BottomNav from '../components/BottomNav'
import Vue from 'vue'
export default {
  name: 'Strategy',
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
    window.onscroll = function() {
      var scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
      var topNav = document.getElementById("topNav");
      if (scrollTop > 0) {
        topNav.style.width = "100%";
        topNav.style.position = "fixed";
        topNav.style.top = "0";
        topNav.style.left = "0";
        topNav.style.paddingLeft = "33.5%";
        // topNav.style.zIndex = 11;

      } else{
        // topNav.style.paddingLeft = "0%";
        // topNav.style.width = "32.42%";
        // topNav.style.left = "33.5%";
        // topNav.style.zIndex = 9;

      }
      // if (scrollTop = 0) {
      //   topNav.style.width = "29.42%";
      // }
    };
  },
  components: { Nav, BottomNav }
}
</script>

<style lang="less" scoped>
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 1240px;
  position: relative;
}
.image {
  width: 100%;
}
.logoImg {
  width: 141px;
  height: 86px;
}
.tit {
  text-align: left;
  h1 {
    color: #fce04f;
    font-size: 61px;
    font-family: Impact;
    font-weight: 400;
    border-bottom: 4px solid #fce04f;
    width: 67px;
  }
  p {
    font-size: 20px;
  }
}
.block {
  min-width: 1240px;
  background-color: #333333;
  height: 100px;
  display: flex;
  align-items: center;
  h1 {
    color: #ffffff;
    line-height: 100px;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    margin: 0 0 0 35%;
    @media screen and (min-width: 140px) {
        font-size: 24px;
      }
    @media screen and (min-width: 1440px) {
      font-size: 24px;
    }
    @media screen and (min-width: 1920px) {
      font-size: 26px;
    }
    span {
      border-bottom: 4px solid #fce04f;
      padding-bottom: 5px;
    }
  }
}
.toptit {
  width: 100%;
  height: 56px;
}
.course {
  // padding-top: 85px;
  // height: 1355px;
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
<style lang="less">
// .el-carousel__container {
//   height: 500px;
// }
// .el-submenu__title:hover{
//   background-color: #fff !important;
// }
.el-submenu__title{
  color: #333 !important;
}
.el-submenu__title a{
  color: #333 !important;
}
</style>